<template>
    	<!-- <div align="center">
			<span  style="font-size:18px;font-weight:bold">{{displayMessage}}</span>
		</div> -->
    <div style="height:250px;width:400px;margin:auto">
      <object data="assets/img/nodataavailable-image.svg"></object>
    </div>
</template>

<script>
export default {
   data(){
       return{

       }
   },
  props:['displayMessage'] 
}
</script>

<style lang="scss">

</style>
